module.exports = __webpack_public_path__ + "media/images/reviewed-logo-white-16cd079bfd0a5f98a29f00b0f59e1789.png";